import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import WifiDescriptEditingModal from './DescriptionEditingModal/WifiDescriptEditingModal';
import { ROLE_ADMIN } from '../../../Optics/Constants/ConstantsOptics';
import ModelWifiDescription from './ModelWifiDescription';
import WifiMonitoringDescription from './WifiMonitoringDescription';
import WifiInfoBdDescription from './WifiInfoBdDescription';
import WifiMetadataBdDescription from './WifiMetadataBdDescription';
import { fetchWifiPointPhotoCount } from '../../Data/LoadingDataWifi';
import ModalPhotoWifiPoint from './ModalPhotoWifiPoint';

const WifiPointDescription = ({ open, onClose, content, snackbarOpen, snackbarMessage, snackbarClass,
  handleCloseSnackbar, copyToClipboard, wifiPointRefreshById, setIsComponentChangeCoorWifi}) => {



   const [user, setUser] = useState(localStorage.getItem('username'));
   const [role, setRole] = useState(localStorage.getItem('roleId'));
   const [openModalFoto, setOpenModalFoto] = useState(false);
   const [fileCount, setFileCount] = useState(0);
   const [openModalEditing, setOpenModalEditing] = useState(false);

  const openModalEditingContent = () => {
    setOpenModalEditing(true);
  }; 
  
   const openModalFotoFile = () => {     
          setOpenModalFoto(true);
       }; 

      useEffect(() => {
              const updateFileCount = async () => {  
                const count = await fetchWifiPointPhotoCount(content.id);
                if (count !== null) {
                  setFileCount(count); 
                }
              };
              updateFileCount();
            });


  // Карта иконок
const wifiIcons = {
  1: {
    planned: "./planned_wifi_bs.png",
    normal: "./wifi_ap.png"
  },
  2: {
    planned: "./planned_wifi_st.png",
    normal: "./wifi_station.png"
  },
  3: {
    planned: "./planned_wifi_ap.png",
    normal: "./wifi_hotspot.png"
  }
};

// Функция выбора иконки
const getWifiIcon = (wifiTypeId, planned) => {
  const type = wifiIcons[wifiTypeId] || wifiIcons[1]; // default — тип 1
  return planned === 1 ? type.planned : type.normal;
};



  return (
    <Dialog open={open} className="dialogStyle" maxWidth={false} PaperProps={{ sx: { width: 'auto', maxHeight: '90vh'}}}>
    <DialogContent>

      <div
  style={{
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  }}
>


    <img
      src={getWifiIcon(content.wifiTypeId, content.planned)}
      width="30"
      height="30"
      style={{ marginRight: "5px" }}
    />

    <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #080808ff'}}>Wi-Fi</label>

    <label
      style={{
        color: content.planned === 1 ? '#ff5c5cff' : '#dfab01',
        fontSize: '20px',
        fontFamily: 'unset',
        marginLeft: '10px',
        textShadow: '2px 2px 4px #000000ff'
      }}
    >
      {content.planned === 1 ? '(Проектная)' : ''}
    </label>

       <button onClick={openModalFotoFile} className="buttonIsPhotoWifiPoint" >
         Фото 
         <span className={`countCircle ${fileCount > 0 ? 'green' : 'red'}`}>
           {fileCount > 0 ? fileCount : 'нет'}
          </span>
        </button>
  </div>
  

    <hr className='hr-gradient'/>
      <label style={{ color: '#131313ff', fontWeight: 'bold'}}>ID: <span style={{ color: '#ebebebff',textShadow: '2px 2px 4px #0f0f0fff' }}>{content.id}</span></label>
      <Button 
          style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
          onClick={() => { copyToClipboard(content.id, "фоб"); }}>
          <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
      <br/>
      <label style={{ color: '#131313ff', fontWeight: 'bold'}}>Территория: <span style={{ color: '#ebebebff',fontWeight: 'normal' ,textShadow: '2px 2px 4px #0f0f0fff'}}>{content.canton} {content.region} {content.area}</span> </label>
      <br/>
        {content?.street && (
          <>
          <label style={{ color: '#131313ff', fontWeight: 'bold',fontSize: '14px' }}>
            Адрес:{' '}
            <span
              style={{
                color: '#ebebebff',
                fontWeight: 'normal',
                textShadow: '2px 2px 4px #0f0f0fff',
                fontSize: '14px'
              }}
            >
              {content.street}, {content.house}, под. {content.entrance}
            </span>
          </label>
            <hr className='hr-gradient'/>
           </>
        )}   
   
      <label style={{ color: '#131313ff', fontWeight: 'bold'}}>Тип: <span style={{ color: '#ebebebff',fontWeight: 'normal',textShadow: '2px 2px 4px #0f0f0fff'}}>{content.wifiTypePoint}</span> </label>
      <br/>
      
     <div style={{ display: "flex", gap: "5px", alignItems: "flex-start" }}>
        {/* Левая колонка */}
        <div style={{ display: "flex", flexDirection: "column", gap: "0px", flex: 1 }}>
          <ModelWifiDescription content={content} />
          <WifiInfoBdDescription content={content} role={role}/>
          <WifiMetadataBdDescription content={content} />
        </div>

        {/* Правая колонка */}
        {(content.planned === 0 && (content.wifiTypeId === 1 || content.wifiTypeId === 2)) ? (
            <div style={{ flex: 1 }}>
              <WifiMonitoringDescription content={content} />
            </div>
         ) : null}

     </div>
 
    </DialogContent>

    <DialogActions>
       {(user === content.authorId || role === ROLE_ADMIN) && (
      <Button onClick={openModalEditingContent} class='buttonIsEditWifi'>
          Редактировать
      </Button>
       )}
    
      <Button onClick={onClose} class='buttonIsCloseWifi'>
        Закрыть
      </Button>
    </DialogActions>

   {/* Snackbar */}
   <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />
      
      {/* Modal редактирование WIFI*/}
      <WifiDescriptEditingModal
        open={openModalEditing}
        onClose={() => setOpenModalEditing(false)}
        onClose2={onClose}
        content={content}
        wifiPointRefreshById={wifiPointRefreshById}
        setIsComponentChangeCoorWifi={setIsComponentChangeCoorWifi}
        getWifiIcon={getWifiIcon}
      />   

       {/* Modal Photo*/}
       <ModalPhotoWifiPoint
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          id={content.id}
          authorId={content.authorId}
          user={user}  
          role={role}   
       />     

           
    </Dialog> 
  );
}

export default WifiPointDescription;